// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/denr logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/Minerals.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-blue: #00b4d8;
    --dark-blue: #023e8a;
    --overlay-background: rgba(255, 255, 255, 0.308);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.home-wrapper {
    height: 100vh; 
    display: flex;
    flex-direction: column;
    overflow: hidden; /* This should prevent scrolling */
    position: relative; /* Added to ensure proper stacking */
}

.main-header {
    background-color: #0096c7;
    padding: 0.5rem 0;
    color: white;
}

.header-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo-section {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.logo {
    width: 50px; 
    height: 50px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); 
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
}

.header-text h1 {
    margin: 2px;
    font-size: 1.2rem;
}

.header-text p {
    margin: 0;
    font-size: 0.8rem;
    opacity: 0.9;
}

main {
    flex: 1 1;
    position: relative;
    overflow: hidden; 
}

.intro-section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 5vh;
    overflow: hidden; 
}

.intro-section::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.4;
    background-color: rgba(0, 0, 0, 0.5); 
    z-index: -2;
}
.intro-section::after {
    content: "";
    position:absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color:  rgba(0, 0, 0, 0.5); 
    z-index: -1;
 }
.intro-content {
    max-width: 700px;
    padding: 0 1rem;
    position: relative;
    z-index: 1;
    margin-top: 2rem; 
}

.intro-content h2 {
    color: white;
    font-size: 2.0rem;
    margin-bottom: 1rem;
    text-align: center;
}

.intro-description {
    font-size: 1.1rem;
    color: white;
    margin-bottom: 1rem;
    text-align: center;
}

.quote-box {
    background: linear-gradient(45deg, rgba(15, 100, 2, 0.7), rgba(4, 99, 26, 0.578), rgba(255, 255, 0, 0.7));
    background-size: 300% 300%;
    animation: rgbAnimation 6s infinite alternate;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    margin: 1.5rem 0;
    color: white;
    text-align: center;
}

.roles-section {
    position: relative;
    z-index: 2;
    padding: 2rem 1rem;
    margin-top: auto; 
    margin-top: 45vh; 
}

.section-content h2 {
    text-align: center;
    color: rgb(255, 255, 255);
    margin-bottom: 1.5rem;
}

.roles-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 1.5rem;
    margin: 0 auto;
    width: 100%;
    max-width: 900px;
    padding: 0 1rem;
}

.role-card {
    background-color: rgb(54, 147, 222);
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    padding: 1.5rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}

.role-card:hover {
    color: white;
    background: rgb(139, 168, 227);
    transform: translateY(-5px);
}

.role-icon {
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

.main-footer {
    background-color: #333;
    color: white;
    padding: 0px;
    position: relative;
    z-index: 2;
}

.footer-content {
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
}

.footer-info p {
    margin: 0.3rem 0;
    font-size: 0.8rem;
    opacity: 0.8;
}
/* Popup Overlay */
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease-out;
}

/* Modal Container */
.qualifications-modal {
    display: flex;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    width: 1000px;
    max-width: 95%;
    max-height: 90vh;
    overflow: auto;
    animation: slideUp 0.4s ease-out;
}

.modal-left {
    flex: 3 1;
    padding: 20px;
}

.modal-right {
    flex: 1 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

/* Close Button */
.qualification-modal-close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;
    padding: 5px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}
.qualification-modal-close-button:hover {
    background-color: #f0f0f0;
    color: #333;
}

/* Title */
.qualifications-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: center;
}

/* Table Styles */
.qualifications-table {
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
}

.table-header {
    display: flex;
    background-color: #00b7c7;
}

.header-cell {
    flex: 1 1;
    padding: 12px;
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #eee;
}

.header-cell:last-child {
    border-right: none;
}

.table-content {
    display: flex;
}

.content-cell {
    flex: 1 1;
    padding: 15px;
    background-color: #f5f5f5;
    border-right: 1px solid #ddd;
}

.content-cell:last-child {
    border-right: none;
}

.content-cell ul {
    padding-left: 20px;
    margin: 0;
}

.content-cell li {
    margin-bottom: 12px;
    line-height: 1.4;
}

.highlight {
    font-weight: bold;
    color: #ca6702;
}

/* Bureau Info */
.bureau-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 30px;
}

.bureau-logo {
    width: 80px;
    height: 80px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Update path as needed */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 15px;
}

.bureau-name {
    font-weight: bold;
    text-align: center;
    font-size: 16px;
}

/* Apply Now Button */
.apply-button {
    background-color: #00b7c7;
    color: black;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    width: 90%;
    margin: 15px 0 30px;
    transition: background-color 0.2s;
}

.apply-button:hover {
    background-color: #009baa;
}

/* Existing Section */
.existing-section {
    margin-top: auto;
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.existing-section p {
    margin: 5px 0;
    font-weight: bold;
}

.existing-section p:last-of-type {
    margin-bottom: 0; /* Remove bottom margin from the last paragraph */
}

.tracking-button {
    background-color: #d1ff6f;
    color: black;
    border: none;
    border-radius: 4px;
    padding: 12px 20px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    width: 90%;
    margin-top: 5px; /* Reduced from 10px to move it closer to "Click here!" text */
    transition: background-color 0.2s;
}

.tracking-button:hover {
    background-color: #b5e74f;
}

/* Animation Keyframes */
@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Alternative animation for slide down */
.slide-down {
    animation: slideDown 0.4s ease-out !important;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Animation for gradient background */
@keyframes rgbAnimation {
    0% {
        background-position: 0% 50%;
    }
    100% {
        background-position: 100% 50%;
    }
}

/* Responsive styles */
@media (max-width: 768px) {
    .qualifications-modal {
        flex-direction: column;
        width: 90%;
        max-height: 85vh;
    }
    
    .qualification-modal-close-button {
        top: 10px;
        right: 10px;
        font-size: 16px;
        width: 26px;
        height: 26px;
    }
    
    .table-header,
    .table-content {
        flex-direction: column;
    }
    
    .header-cell,
    .content-cell {
        border-right: none;
        border-bottom: 1px solid #ddd;
    }
    
    .header-cell:last-child,
    .content-cell:last-child {
        border-bottom: none;
    }
    
    .modal-right {
        padding-top: 10px;
    }
    
    .bureau-info {
        margin-top: 10px;
        margin-bottom: 20px;
    }
    
    .apply-button,
    .tracking-button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Home.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,kCAAkC;IACpD,kBAAkB,EAAE,oCAAoC;AAC5D;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAgD;IAChD,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA+C;IAC/C,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,oCAAoC;IACpC,WAAW;AACf;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,WAAW;CACd;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yGAAyG;IACzG,0BAA0B;IAC1B,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;AACnC;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,UAAU;AACV;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAgD,EAAE,0BAA0B;IAC5E,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,UAAU;IACV,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,gBAAgB,EAAE,iDAAiD;AACvE;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,UAAU;IACV,eAAe,EAAE,8DAA8D;IAC/E,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,yCAAyC;AACzC;IACI,6CAA6C;AACjD;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sCAAsC;AACtC;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;;QAEI,kBAAkB;QAClB,6BAA6B;IACjC;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;IACf;AACJ","sourcesContent":[":root {\r\n    --primary-blue: #00b4d8;\r\n    --dark-blue: #023e8a;\r\n    --overlay-background: rgba(255, 255, 255, 0.308);\r\n}\r\n\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.home-wrapper {\r\n    height: 100vh; \r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden; /* This should prevent scrolling */\r\n    position: relative; /* Added to ensure proper stacking */\r\n}\r\n\r\n.main-header {\r\n    background-color: #0096c7;\r\n    padding: 0.5rem 0;\r\n    color: white;\r\n}\r\n\r\n.header-content {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 0 1rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.logo-section {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1rem;\r\n}\r\n\r\n.logo {\r\n    width: 50px; \r\n    height: 50px;\r\n    background-image: url('../images/denr logo.png'); \r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    display: block;\r\n}\r\n\r\n.header-text h1 {\r\n    margin: 2px;\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.header-text p {\r\n    margin: 0;\r\n    font-size: 0.8rem;\r\n    opacity: 0.9;\r\n}\r\n\r\nmain {\r\n    flex: 1;\r\n    position: relative;\r\n    overflow: hidden; \r\n}\r\n\r\n.intro-section {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    color: white;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    padding-top: 5vh;\r\n    overflow: hidden; \r\n}\r\n\r\n.intro-section::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-image: url('../images/Minerals.jpg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    opacity: 0.4;\r\n    background-color: rgba(0, 0, 0, 0.5); \r\n    z-index: -2;\r\n}\r\n.intro-section::after {\r\n    content: \"\";\r\n    position:absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color:  rgba(0, 0, 0, 0.5); \r\n    z-index: -1;\r\n }\r\n.intro-content {\r\n    max-width: 700px;\r\n    padding: 0 1rem;\r\n    position: relative;\r\n    z-index: 1;\r\n    margin-top: 2rem; \r\n}\r\n\r\n.intro-content h2 {\r\n    color: white;\r\n    font-size: 2.0rem;\r\n    margin-bottom: 1rem;\r\n    text-align: center;\r\n}\r\n\r\n.intro-description {\r\n    font-size: 1.1rem;\r\n    color: white;\r\n    margin-bottom: 1rem;\r\n    text-align: center;\r\n}\r\n\r\n.quote-box {\r\n    background: linear-gradient(45deg, rgba(15, 100, 2, 0.7), rgba(4, 99, 26, 0.578), rgba(255, 255, 0, 0.7));\r\n    background-size: 300% 300%;\r\n    animation: rgbAnimation 6s infinite alternate;\r\n    padding: 1.5rem;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\r\n    margin: 1.5rem 0;\r\n    color: white;\r\n    text-align: center;\r\n}\r\n\r\n.roles-section {\r\n    position: relative;\r\n    z-index: 2;\r\n    padding: 2rem 1rem;\r\n    margin-top: auto; \r\n    margin-top: 45vh; \r\n}\r\n\r\n.section-content h2 {\r\n    text-align: center;\r\n    color: rgb(255, 255, 255);\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.roles-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    gap: 1.5rem;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n    max-width: 900px;\r\n    padding: 0 1rem;\r\n}\r\n\r\n.role-card {\r\n    background-color: rgb(54, 147, 222);\r\n    border: 2px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    width: 100%;\r\n    max-width: 400px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.role-card:hover {\r\n    color: white;\r\n    background: rgb(139, 168, 227);\r\n    transform: translateY(-5px);\r\n}\r\n\r\n.role-icon {\r\n    font-size: 2rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.main-footer {\r\n    background-color: #333;\r\n    color: white;\r\n    padding: 0px;\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n\r\n.footer-content {\r\n    max-width: 900px;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n}\r\n\r\n.footer-info p {\r\n    margin: 0.3rem 0;\r\n    font-size: 0.8rem;\r\n    opacity: 0.8;\r\n}\r\n/* Popup Overlay */\r\n.popup-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n/* Modal Container */\r\n.qualifications-modal {\r\n    display: flex;\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\r\n    width: 1000px;\r\n    max-width: 95%;\r\n    max-height: 90vh;\r\n    overflow: auto;\r\n    animation: slideUp 0.4s ease-out;\r\n}\r\n\r\n.modal-left {\r\n    flex: 3;\r\n    padding: 20px;\r\n}\r\n\r\n.modal-right {\r\n    flex: 1;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    position: relative;\r\n}\r\n\r\n/* Close Button */\r\n.qualification-modal-close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    color: #666;\r\n    padding: 5px;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s;\r\n}\r\n.qualification-modal-close-button:hover {\r\n    background-color: #f0f0f0;\r\n    color: #333;\r\n}\r\n\r\n/* Title */\r\n.qualifications-title {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    margin-bottom: 15px;\r\n    text-align: center;\r\n}\r\n\r\n/* Table Styles */\r\n.qualifications-table {\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n}\r\n\r\n.table-header {\r\n    display: flex;\r\n    background-color: #00b7c7;\r\n}\r\n\r\n.header-cell {\r\n    flex: 1;\r\n    padding: 12px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n    border-right: 1px solid #eee;\r\n}\r\n\r\n.header-cell:last-child {\r\n    border-right: none;\r\n}\r\n\r\n.table-content {\r\n    display: flex;\r\n}\r\n\r\n.content-cell {\r\n    flex: 1;\r\n    padding: 15px;\r\n    background-color: #f5f5f5;\r\n    border-right: 1px solid #ddd;\r\n}\r\n\r\n.content-cell:last-child {\r\n    border-right: none;\r\n}\r\n\r\n.content-cell ul {\r\n    padding-left: 20px;\r\n    margin: 0;\r\n}\r\n\r\n.content-cell li {\r\n    margin-bottom: 12px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.highlight {\r\n    font-weight: bold;\r\n    color: #ca6702;\r\n}\r\n\r\n/* Bureau Info */\r\n.bureau-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 20px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.bureau-logo {\r\n    width: 80px;\r\n    height: 80px;\r\n    background-image: url('../images/denr logo.png'); /* Update path as needed */\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.bureau-name {\r\n    font-weight: bold;\r\n    text-align: center;\r\n    font-size: 16px;\r\n}\r\n\r\n/* Apply Now Button */\r\n.apply-button {\r\n    background-color: #00b7c7;\r\n    color: black;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 12px 20px;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    width: 90%;\r\n    margin: 15px 0 30px;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.apply-button:hover {\r\n    background-color: #009baa;\r\n}\r\n\r\n/* Existing Section */\r\n.existing-section {\r\n    margin-top: auto;\r\n    text-align: center;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.existing-section p {\r\n    margin: 5px 0;\r\n    font-weight: bold;\r\n}\r\n\r\n.existing-section p:last-of-type {\r\n    margin-bottom: 0; /* Remove bottom margin from the last paragraph */\r\n}\r\n\r\n.tracking-button {\r\n    background-color: #d1ff6f;\r\n    color: black;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 12px 20px;\r\n    font-weight: bold;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    width: 90%;\r\n    margin-top: 5px; /* Reduced from 10px to move it closer to \"Click here!\" text */\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.tracking-button:hover {\r\n    background-color: #b5e74f;\r\n}\r\n\r\n/* Animation Keyframes */\r\n@keyframes fadeIn {\r\n    from { opacity: 0; }\r\n    to { opacity: 1; }\r\n}\r\n\r\n@keyframes slideUp {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(30px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* Alternative animation for slide down */\r\n.slide-down {\r\n    animation: slideDown 0.4s ease-out !important;\r\n}\r\n\r\n@keyframes slideDown {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-30px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* Animation for gradient background */\r\n@keyframes rgbAnimation {\r\n    0% {\r\n        background-position: 0% 50%;\r\n    }\r\n    100% {\r\n        background-position: 100% 50%;\r\n    }\r\n}\r\n\r\n/* Responsive styles */\r\n@media (max-width: 768px) {\r\n    .qualifications-modal {\r\n        flex-direction: column;\r\n        width: 90%;\r\n        max-height: 85vh;\r\n    }\r\n    \r\n    .qualification-modal-close-button {\r\n        top: 10px;\r\n        right: 10px;\r\n        font-size: 16px;\r\n        width: 26px;\r\n        height: 26px;\r\n    }\r\n    \r\n    .table-header,\r\n    .table-content {\r\n        flex-direction: column;\r\n    }\r\n    \r\n    .header-cell,\r\n    .content-cell {\r\n        border-right: none;\r\n        border-bottom: 1px solid #ddd;\r\n    }\r\n    \r\n    .header-cell:last-child,\r\n    .content-cell:last-child {\r\n        border-bottom: none;\r\n    }\r\n    \r\n    .modal-right {\r\n        padding-top: 10px;\r\n    }\r\n    \r\n    .bureau-info {\r\n        margin-top: 10px;\r\n        margin-bottom: 20px;\r\n    }\r\n    \r\n    .apply-button,\r\n    .tracking-button {\r\n        width: 100%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
